import React, { FC, useState, memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { areEqual } from "Utils/areEqual";
import SingleDestination from "Components/SingleDestination";
import { setSelectedDestinations } from "Containers/Destinations";
import { setStopState, setCurrentStop, StopState } from "Containers/Stops";
import { stopChangeTrigger } from "Containers/Stops/currentStop.Actions";
import {
  setDestinationsViewTrigger,
  SetDestinationsViewTriggerType,
} from "Containers/Destinations/actions";

interface Props {
  destination: any;
  selected: boolean;
  showHideList: (trigger: SetDestinationsViewTriggerType) => void;
  googleMap: any;
}

const SingleDestinationContainer: FC<Props> = memo(
  ({ destination, showHideList, selected = false, googleMap }: Props) => {
    const [hover, setHover] = useState(false);
    const dispatch = useDispatch();
    const stops = useSelector(
      ({ stops: stopsList }: any) => stopsList,
      areEqual
    );

    const { openCount } = useSelector(
      (selectors: any) => selectors.destinations
    );

    const changeHover = useCallback(() => setHover(!hover), [hover]);

    const bottomStopNavTitle = document.getElementById("bottomNavTitle");
    if (bottomStopNavTitle) bottomStopNavTitle.focus();

    const handleClick = useCallback(() => {
      const { id } = destination;

      dispatch(setSelectedDestinations(destination.photoThumb));
      // Store the current stop in Redux. It will be used in the Destinations container
      dispatch(setCurrentStop(id, stopChangeTrigger.DESTINATION_LIST));

      // Select the destination on the map
      dispatch(setStopState([id], StopState.Selected));

      if (showHideList) {
        showHideList(setDestinationsViewTrigger.DESTINATION_CLICK);
      }

      // eslint-disable-next-line no-undef
      const latLng = googleMap.isCustomTiledMap
        ? new window.google.maps.LatLng(
            destination.customLat,
            destination.customLng
          )
        : new window.google.maps.LatLng(
            destination.realLat,
            destination.realLng
          );

      googleMap.panTo(latLng);
    }, [destination, dispatch, googleMap, showHideList]);

    return (
      <SingleDestination
        destination={destination}
        selected={selected}
        changeHover={changeHover}
        hover={hover}
        click={handleClick}
        stops={stops}
        openCount={openCount}
      />
    );
  },
  areEqual
);

export default SingleDestinationContainer;
try {
    // @ts-ignore
    SingleDestination.displayName = "SingleDestination";
    // @ts-ignore
    SingleDestination.__docgenInfo = { "description": "", "displayName": "SingleDestination", "props": { "destination": { "defaultValue": null, "description": "", "name": "destination", "required": true, "type": { "name": "any" } }, "selected": { "defaultValue": null, "description": "", "name": "selected", "required": true, "type": { "name": "boolean" } }, "showHideList": { "defaultValue": null, "description": "", "name": "showHideList", "required": true, "type": { "name": "(trigger: any) => void" } }, "googleMap": { "defaultValue": null, "description": "", "name": "googleMap", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/SingleDestination/SingleDestination.tsx#SingleDestination"] = { docgenInfo: SingleDestination.__docgenInfo, name: "SingleDestination", path: "src/shared/containers/SingleDestination/SingleDestination.tsx#SingleDestination" };
}
catch (__react_docgen_typescript_loader_error) { }